import {NgModule} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';
import { InputTextModule } from 'primeng/inputtext';
import { ChipModule } from 'primeng/chip';
import { CardModule } from 'primeng/card';
import { FieldsetModule } from 'primeng/fieldset';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { DataViewModule, DataViewLayoutOptions } from 'primeng/dataview';
import { RatingModule } from 'primeng/rating';
import { TagModule } from 'primeng/tag';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox'
import {StyleClassModule} from 'primeng/styleclass';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { BadgeModule } from 'primeng/badge';
import { PaginatorModule } from 'primeng/paginator';
import { AccordionModule } from 'primeng/accordion';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { EditorModule } from 'primeng/editor';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { SelectButtonModule } from 'primeng/selectbutton';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { TreeModule } from 'primeng/tree';
import { DragDropModule } from 'primeng/dragdrop';
import { TabMenuModule } from 'primeng/tabmenu';
import { TreeSelectModule } from 'primeng/treeselect';
import { FileUploadModule } from 'primeng/fileupload';
import { DividerModule } from 'primeng/divider';
import { SpeedDialModule } from 'primeng/speeddial';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { SkeletonModule } from 'primeng/skeleton';
import { MultiSelectModule } from 'primeng/multiselect';
import { ChartModule } from 'primeng/chart';
import { ToolbarModule } from 'primeng/toolbar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { StepsModule } from 'primeng/steps';
import { SplitterModule } from 'primeng/splitter';
import { TimelineModule } from 'primeng/timeline';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@NgModule({
    imports: [
      ButtonModule
    ],
    exports: [
        ButtonModule,
        SidebarModule,
        InputTextModule,
        ChipModule,
        CardModule,
        FieldsetModule,
        AvatarModule,
        MenuModule,
        DataViewModule,
        RatingModule,
        TagModule,
        DropdownModule,
        CheckboxModule,
        StyleClassModule,
        RadioButtonModule,
        ToggleButtonModule,
        BadgeModule,
        PaginatorModule,
        AccordionModule,
        BreadcrumbModule,
        EditorModule,
        DialogModule,
        TableModule,
        SelectButtonModule,
        OrganizationChartModule,
        TreeModule,
        DragDropModule,
        TabMenuModule,
        TreeSelectModule,
        FileUploadModule,
        DividerModule,
        SpeedDialModule,
        ConfirmDialogModule,
        ToastModule,
        MessagesModule,
        SkeletonModule,
        MultiSelectModule,
        ChartModule,
        ToolbarModule,
        AutoCompleteModule,
        StepsModule,
        SplitterModule,
        TimelineModule,
        OverlayPanelModule
    ]
  })
export class PrimeNgModule {}